import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Rule } from '../../../interfaces/Rule';
import { Ruleset } from '../../../interfaces/Ruleset';
import { RulesetResult, IsPropertyLeased } from '../../rules';
import IsPropertyLandlord from '../../rules/IsPropertyLandlord';
import { BaseRuleset } from '../BaseRuleset';

class PropertyOwnerRelatedToBusinessRuleset
  extends BaseRuleset
  implements Ruleset
{
  protected rules: Rule[] = [IsPropertyLeased];

  private index: number;

  public setIndex(index: number): PropertyOwnerRelatedToBusinessRuleset {
    this.index = index;
    return this;
  }

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isLeased = IsPropertyLeased.evaluate(data);
    const isLandlord = IsPropertyLandlord.setIndex(this.index).evaluate(data);

    return isLeased && isLandlord
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new PropertyOwnerRelatedToBusinessRuleset();
